import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { DXP_REGISTRATION_ROUTE } from "../Helpers/constants";
import "./css/registration.css";
import EnterEmail from "./EnterEmail";
import SelectYourCompany from "./SelectYourCompany";
import AdobeIdVerification from "./AdobeIdVerification";
import UserProfile from "./UserProfile";
import CompanyInformation from "./CompanyInformation";
import MembershipOptions from "./MembershipOptions";
import { setRegisteredCompanies, setImsProfileExists } from "../Redux/actions";

const DEMO_COMPANIES = [
  {
    id: "preview-co-1",
    name: "Acme Partner Inc.",
    countryName: "United States",
    primaryBusiness: "Technology",
    level: "Gold",
  },
  {
    id: "preview-co-2",
    name: "Globex Solutions Ltd.",
    countryName: "Great Britain",
    primaryBusiness: "Solution",
    level: "Silver",
  },
];

/**
 * Dev / QA: stacked view of all new registration steps with previewMode
 * (no navigation, no API submit). Open at basename + registration-components-preview
 */
function RegistrationComponentsPreview() {
  const dispatch = useDispatch();

  useEffect(() => {
    const emailKey = "email";
    const typeKey = "selectedRegisterCompanyType";
    const prevEmail = localStorage.getItem(emailKey);
    const prevType = localStorage.getItem(typeKey);

    dispatch(setRegisteredCompanies(DEMO_COMPANIES, 1));
    dispatch(setImsProfileExists(true));
    localStorage.setItem(emailKey, "preview.user@example.com");
    localStorage.setItem(typeKey, "standaloneCompany");

    return () => {
      if (prevEmail === null) localStorage.removeItem(emailKey);
      else localStorage.setItem(emailKey, prevEmail);
      if (prevType === null) localStorage.removeItem(typeKey);
      else localStorage.setItem(typeKey, prevType);
      dispatch(setRegisteredCompanies([], 0));
    };
  }, [dispatch]);

  return (
    <div className="dxp-reg-preview-root">
      <header className="dxp-reg-preview-banner">
        <div>
          <span className="dxp-reg-preview-header-label">
            Registration UI preview — all steps
          </span>
          <div className="dxp-reg-preview-header-meta">
            Demo email + companies are seeded while this page is open. Actions
            show a toast (preview mode).
          </div>
        </div>
        <Link to={DXP_REGISTRATION_ROUTE} className="dxp-reg-preview-nav-link">
          ← Back to live wizard
        </Link>
      </header>

      <div className="dxp-reg-preview-main">
        <section id="preview-enter-email" className="dxp-reg-preview-section">
          <h2 className="dxp-reg-preview-section-title">
            Step 0 — Enter email
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <EnterEmail previewMode />
          </div>
        </section>

        <section
          id="preview-select-company"
          className="dxp-reg-preview-section"
        >
          <h2 className="dxp-reg-preview-section-title">
            Step 1 — Select your company
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <SelectYourCompany previewMode />
          </div>
        </section>

        <section id="preview-adobe-id" className="dxp-reg-preview-section">
          <h2 className="dxp-reg-preview-section-title">
            Step 2 — Adobe ID verification
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <AdobeIdVerification previewMode />
          </div>
        </section>

        <section id="preview-user-profile" className="dxp-reg-preview-section">
          <h2 className="dxp-reg-preview-section-title">
            Step 3 — User profile
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <UserProfile previewMode />
          </div>
        </section>

        <section id="preview-company-info" className="dxp-reg-preview-section">
          <h2 className="dxp-reg-preview-section-title">
            Step 4 — Company information (standalone)
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <CompanyInformation previewMode />
          </div>
        </section>

        <section id="preview-membership" className="dxp-reg-preview-section">
          <h2 className="dxp-reg-preview-section-title">
            Step 5 — Membership options
          </h2>
          <div className="dxp-reg-preview-step-frame">
            <MembershipOptions previewMode />
          </div>
        </section>
      </div>
    </div>
  );
}

export default RegistrationComponentsPreview;
